import { HttpClient,HttpBackend,HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserProfile } from '../model/user-profile';
import { EnvService } from '../core/env.service';
import {LocalStorageService} from '../core/localstorage-service';
import { map, switchMap } from 'rxjs/operators'
import { AuthService } from '../core/auth-service.component';
import { BehaviorSubject, Subject, Observable, from } from 'rxjs';

export interface RoutesDto {
    DefaultApp: string,
    Apps: Array<string>,
    RedirectNewTool:boolean
}
  
const headers = new HttpHeaders().set('Content-Type','application/json')
@Injectable()
export class UserService {
    userProfile: UserProfile;
   
    constructor(
        private _httpClient: HttpClient,
        public _env: EnvService,
        private _localStorageService: LocalStorageService,
        private _httpClientBackend: HttpClient,
        private _httpHandler: HttpBackend,
        private _authService: AuthService
        ) {
            this._httpClientBackend = new HttpClient(_httpHandler);
     }
    
    getProfile(): Observable<UserProfile> {
        return from(this._authService.getAccessToken()).pipe(
            switchMap((token)=>
            {
                return this._httpClientBackend.get<UserProfile>(this._env.apictgf + 'User/GetProfile',{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
                .pipe(map((res: any) => res));
            })
        )
    }

    hasCtDashboardAccess(): Observable<boolean> {
        return this._httpClient.get<boolean>(this._env.apictgf + 'User/HasCtDashboardAccess')
        .pipe(map((res: any) => res));
    }

    redirectToNewTool(FirstLogin: Boolean ): Observable<any> {
        return this._httpClient.get<any>(this._env.apictgf + 'User/RedirectToNewTool?firstLogin='+FirstLogin)
        .pipe(map((res: any) => res));
    }

    getPageAccess(): Observable<RoutesDto>{
        return from(this._authService.getAccessToken())
        .pipe(
            switchMap((token)=>
            {
                return this._httpClientBackend.get<any>(this._env.apictgf + 'user/GetPageAuthorization',{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
                .pipe(map((res: any) => res));
            })
        );
    }

    getApplicationSettings(): Observable<any>{
        return from(this._authService.getAccessToken())
            .pipe(
                switchMap((token)=>
                {
                    return this._httpClientBackend.get<any>(this._env.apictgf + 'user/GetApplicationSettings',{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
                    .pipe(map((res: any) => res));
                })
            )
        
    }

    UpdateApplicationSettings(appSettings:any): Observable<any>{
        return from(this._authService.getAccessToken())
            .pipe(
                switchMap((token)=>
                {
                    return this._httpClientBackend.post<any>(this._env.apictgf + 'user/UpdateApplicationSettings',appSettings,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
                    .pipe(map((res: any) => res));
                })
            )
    }

    AddApplicationSettings(appSettings:any): Observable<any>{
        return from(this._authService.getAccessToken())
        .pipe(
            switchMap((token)=>
            {
                return this._httpClientBackend.post<any>(this._env.apictgf + 'user/AddApplicationSettings',appSettings,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
                .pipe(map((res: any) => res));
            })
        )
    }

    getFileAttachment(invoiceId: String):Observable<Array<any>>{
        return this._httpClient.get<Array<any>>(this._env.apiWebResolution +'WebResInvoice/GetWebResFileAttachment?invoiceId='+ invoiceId)
        .pipe(map((res: any) => res));
    }

    GetEmailAlert():any {
        return this._httpClient.get<boolean>(this._env.apictgf + 'User/GetEmailAlert')
        .pipe(map((res: any) => res));
    }
    
    
    AddEmailAlert(emailAlertList:any):any {
        return this._httpClient.post<any>(this._env.apictgf + 'User/AddEmailAlert',emailAlertList)
        .pipe(map((res: any) => res));
    }

    GetUserGuide():any {
        return this._httpClient.get<boolean>(this._env.apictgf + 'User/GetUserGuide')
        .pipe(map((res: any) => res));
    }

    //this download can be open window.open(url);
    GetUserGuideAttachment(id: number):Observable<Blob> {
        return this._httpClient.get(this._env.apictgf +'User/GetUserGuideAttachment?userGuideId='+id,{ headers: new HttpHeaders({'ngsw-bypass': 'true' ,
            'Content-Type': 'application/json',
          }),
           responseType: 'blob'},);
    }

    CheckCookie(): Observable<any> {
        return this._httpClient.get<any>(this._env.apictgf + 'User/CheckCookie')
        .pipe(map((res: any) => res));
    }
}